import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarMinimizer,
  //CSidebarNavDropdown,
  CSidebarNavItem,
} from "@coreui/react";

//import CIcon from '@coreui/icons-react';

import {
  minimizeDashboard,
  showDashboard,
} from "../../redux/actions/dashboard";
import { RootState } from "../../store";

// sidebar nav config
import { getRouteName, getRoutePath } from "../../routes";
import ThemeToggle from "./ThemeToggle";
import { SHOW_SIFEN_INCIDENTS } from "../../config/features";

const Sidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state: RootState) => state.dashboard.sidebarShow);
  const minimize = useSelector(
    (state: RootState) => state.dashboard.sidebarMinimize,
  );

  const history = useHistory();

  useEffect(() => {
    return history.listen((_) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <CSidebar
      show={show}
      onShowChange={(val: boolean) => {
        dispatch(showDashboard(val));
        window.localStorage.setItem("sidebarShow", val ? "true" : "false");
      }}
      minimize={minimize}
      onMinimizeChange={(val: boolean) => {
        dispatch(minimizeDashboard(!val));
        window.localStorage.setItem("sidebarMinimize", !val ? "true" : "false");
      }}
      dropdownMode={"noAction"}
    >
      <CSidebarBrand className="d-md-down-none" to="/">
        {minimize ? (
          <img
            src="/smart-logo-no-text-white.webp"
            alt="SmartDoc"
            style={{ height: "32px", width: "32px", objectFit: "contain" }}
          />
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img
              src="/smart-logo-no-text-white.webp"
              alt="SmartDoc"
              style={{ height: "32px", width: "32px", objectFit: "contain" }}
            />
            <span
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                color: "#ffffff",
              }}
            >
              SmartDoc
            </span>
          </div>
        )}
      </CSidebarBrand>
      <CSidebarNav>
        <CSidebarNavItem
          name={getRouteName("dashboard")}
          to={getRoutePath("dashboard")}
          icon={"cil-home"}
        ></CSidebarNavItem>
        <CSidebarNavItem
          name={getRouteName("stats")}
          to={getRoutePath("stats")}
          icon={"cil-chart-pie"}
        ></CSidebarNavItem>
        <CSidebarNavItem
          name={getRouteName("operations")}
          to={getRoutePath("operations")}
          icon={"cil-graph"}
        ></CSidebarNavItem>
        {SHOW_SIFEN_INCIDENTS && (
          <>
            <CSidebarNavItem
              name={getRouteName("sifenIncidents")}
              to={getRoutePath("sifenIncidents")}
              icon={<i className="c-sidebar-nav-icon fa fa-flag"></i>}
            />
            <CSidebarNavItem
              name={getRouteName("supportEmailSettings")}
              to={getRoutePath("supportEmailSettings")}
              icon={<i className="c-sidebar-nav-icon fa fa-envelope" />}
            />
          </>
        )}
        <CSidebarNavItem
          name={getRouteName("users")}
          to={getRoutePath("users")}
          icon={"cil-people"}
        ></CSidebarNavItem>
        <CSidebarNavItem
          name={getRouteName("taxPayers")}
          to={getRoutePath("taxPayers")}
          icon={"company-icon"}
        ></CSidebarNavItem>
        <CSidebarNavItem
          name={getRouteName("documentErrors")}
          to={getRoutePath("documentErrors")}
          icon={<i className="c-sidebar-nav-icon fa fa-book-bookmark"></i>}
        ></CSidebarNavItem>
        <CSidebarNavItem
          name={getRouteName("systemNotifications")}
          to={getRoutePath("systemNotifications")}
          icon={<i className="c-sidebar-nav-icon fa fa-bullhorn"></i>}
        ></CSidebarNavItem>

        {/*<CCreateElement
          items={navigation}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />*/}
      </CSidebarNav>
      <ThemeToggle placement="sidebar" />
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  );
};

export default Sidebar;
